import React from 'react';
import DashboardCard from '../../../components/ACS-Dashboard/ACS-Dashboard-Blocks/DashboardCard';
import ScrollableContainer from '../../../components/ACS-Dashboard/ACS-Blocks/ScrollableContainer';
import { Package, Truck, Clock, AlertTriangle, Archive, CalendarClock, Flag } from 'lucide-react';

const DashboardList = () => {
  const cardsData = [
    { title: "Delivered Shipments", percentage: "+10%", comparisonText: "vs last week", mainValue: "25", buttonText: "View", icon: Package },
    { title: "In-transit Shipments", percentage: "+5%", comparisonText: "vs yesterday", mainValue: "15", buttonText: "Track", icon: Truck },
    { title: "Partially Shipped Orders", percentage: "-2%", comparisonText: "vs last month", mainValue: "8", buttonText: "Resolve", icon: Clock },
    { title: "Delayed Shipments", percentage: "-1%", comparisonText: "vs last month", mainValue: "3", buttonText: "Check Issue", icon: AlertTriangle },
    { title: "Backordered Items", percentage: "+7%", comparisonText: "vs last week", mainValue: "12", buttonText: "View", icon: Archive },
    { title: "Upcoming Deliveries", percentage: "+5%", comparisonText: "vs next week", mainValue: "18", buttonText: "Plan", icon: CalendarClock },
    { title: "Exceptions Flagged", percentage: "+7%", comparisonText: "vs last month", mainValue: "20", buttonText: "Review", icon: Flag }
  ];

  return (
    <div className="p-fluid-1 bg-color-custom-bg-purple">
      <ScrollableContainer direction="x" className="scrollbar-none">
        <div className="flex gap-[clamp(0.5rem,1cqw,1rem)]">
          {cardsData.map((card, index) => (
            <div
              key={index}
              className="scroll-snap-align-start"
              style={{
                minWidth: 'clamp(12rem,30cqw,11rem)',
                flex: '0 0 auto'
              }}
            >
              <DashboardCard {...card} />
            </div>
          ))}
        </div>
      </ScrollableContainer>
    </div>
  );
};

export default DashboardList;
